import React from "react";
import { VennChart } from "../../../Common";
import { BiMale } from "@react-icons/all-files/bi/BiMale";
import { IGPSBenchmarkCommonData } from "../../../../Models/IGPSData";

interface VisitorLoyaltySharingProps {
  benchmarkCommonData: IGPSBenchmarkCommonData;
  polygons: string[];
}

export const VisitorLoyaltySharing = ({
    benchmarkCommonData,
    polygons,
}: VisitorLoyaltySharingProps) => {
    let percent1 = 0;
    let percent2 = 0;
    let centralPercent = 0;

    benchmarkCommonData.visitorLoyalty.forEach((loyaltyData, i) => {
        const roundedValue = Math.round(loyaltyData.value * 100) / 100;
        if (loyaltyData.jobIds.length > 1) {
            centralPercent = roundedValue;
        } else if (percent1 === 0) {
            percent1 = roundedValue;
        } else {
            percent2 = roundedValue;
        }
    });

    const chart = (
        <>
            <VennChart
                percent1={percent1}
                percent2={percent2}
                centralIcon={<BiMale />}
                centralPercent={centralPercent}
                location1Name={polygons[0]}
                location2Name={polygons[1]}
                isActive={true}
            />
        </>
    );
    return (
        <>
            <div style={{ marginBottom: 40 }}>
                <p>
          Shows the % of {polygons[0]}'s visitors also observed at {polygons[1]}{" "}
          (and vice versa).
                </p>
            </div>

            {chart}
        </>
    );
};
